import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { DetailFaq, Faq } from "./pages";

const faqRoutes = [
  {
    path: "/faqs",
    element: (
      <ProtectedRoute isNotEmployee>
        <Faq />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="FAQ" />,
  },
  {
    path: "/faqs/detail/:id",
    element: (
      <ProtectedRoute isNotEmployee>
        <DetailFaq />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="payroll.detail" />,
  },
];

export default faqRoutes;
